import React from 'react';
import { Route } from 'react-router-dom';
import AcademicTerms from '../pages/academicTerms/AcademicTerms';
import AcademicTermsArchive from '../pages/academicTerms/AcademicTermsArchive';
import CreateAcademicTerm from '../pages/academicTerms/CreateAcademicTerm';
import EditAcademicTerm from '../pages/academicTerms/EditAcademicTerm';
import PermissionGuard from '../components/global/PermissionGuard';

const academicTermsRoutes = (
    <>
        <Route
            path="/academic-terms"
            element={
                <PermissionGuard permission="academic_terms_list">
                    <AcademicTerms />
                </PermissionGuard>
            }
        />

        <Route
            path="/academic-terms/archive"
            element={
                <PermissionGuard permission="academic_terms_archive_list">
                    <AcademicTermsArchive />
                </PermissionGuard>
            }
        />

        <Route
            path="/academic-terms/create"
            element={
                <PermissionGuard permission="academic_terms_create">
                    <CreateAcademicTerm />
                </PermissionGuard>
            }
        />

        <Route
            path="/academic-terms/:id/edit"
            element={
                <PermissionGuard permission="academic_terms_edit">
                    <EditAcademicTerm />
                </PermissionGuard>
            }
        />
    </>
);

export default academicTermsRoutes;
